import { useEffect } from 'react'

const isHopTimusShortcut = (event: KeyboardEvent) =>
  (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey && event.key?.toLowerCase() === 'k'

const useHopTimusShortcut = (enabled: boolean, onShortcut: () => void) => {
  useEffect(() => {
    if (!enabled) return undefined

    const onKeyDown = (event: KeyboardEvent) => {
      if (!isHopTimusShortcut(event)) return
      event.preventDefault()
      if (event.repeat) return
      onShortcut()
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [enabled, onShortcut])
}

export default useHopTimusShortcut
